import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var FileFilter = /** @class */ (function (_super) {
    __extends(FileFilter, _super);
    function FileFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FileFilter.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (value) {
            this._description = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileFilter.prototype, "extension", {
        get: function () {
            return this._extension;
        },
        set: function (value) {
            this._extension = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileFilter.prototype, "macType", {
        get: function () {
            return this._macType;
        },
        set: function (value) {
            this._macType = value;
        },
        enumerable: false,
        configurable: true
    });
    return FileFilter;
}(ASObject));
export { FileFilter };
